import {
  OrderRefundMethodOption,
} from '@dapi/sdk';
import {
  cardPaymentTransaction,
  customPaymentTransaction,
  milesPaymentTransactionsZeroMiles,
  paymentDetails,
} from './payment-transaction';

export const refundMethodOptions: OrderRefundMethodOption = {
  id: '6072160342328-DEFAULT',
  paymentDetails: [paymentDetails]
};

export const refundMethodOptionForMiles: OrderRefundMethodOption = {
  id: '0142195550849-DEFAULT',
  paymentDetails: [customPaymentTransaction, cardPaymentTransaction]
};

export const refundMethodOptionForMilesWithoutCancellation: OrderRefundMethodOption = {
  id: '0142195550849-DEFAULT',
  paymentDetails: milesPaymentTransactionsZeroMiles
};
